import style from './index.module.scss';
import { ReactComponent as Arrow } from '../arrow-right.svg';

export const SubMenu = ({ pratiques, isDesktop }) => {
    return (
        <ul className={style.subMenu}>
            {pratiques &&
                pratiques.map((value, id) => (
                    <li key={id}>
                        {!isDesktop && <div className={style.dotedLine} />}
                        <a
                            className={style.pratiqueItem}
                            href={'/pratique/'.concat(value.post_name)}
                        >
                            {value.post_title}
                            <Arrow className={style.arrow} />
                        </a>
                    </li>
                ))}
        </ul>
    );
};
